// extracted by mini-css-extract-plugin
export var twocolWrapper = "TwoColumn-module--twocolWrapper--qoWYl";
export var row = "TwoColumn-module--row--2Ly6V";
export var columnOne = "TwoColumn-module--columnOne--1U_Q9";
export var columnTwo = "TwoColumn-module--columnTwo--114dU";
export var column = "TwoColumn-module--column--1pTcJ";
export var columnHeading = "TwoColumn-module--columnHeading--21ALy";
export var columnText = "TwoColumn-module--columnText--1JcCU";
export var reverseOnMobile = "TwoColumn-module--reverseOnMobile--1itYA";